import React from "react";

// CSS
import "../../css/body-wrap.css";

class BodyWrap extends React.PureComponent {
	render() {
		return <div className="body-wrap">{this.props.children}</div>;
	}
}

export default BodyWrap;



// WEBPACK FOOTER //
// ./src/components/utils/BodyWrap.js